export default "<div class=\"row\">\r\n  <div class=\"col-md-12 \">\r\n    <app-warehouse-list></app-warehouse-list>\r\n  </div>\r\n</div>\r\n"